export const SAVED = () => `The third party client VOD storages have been added successfully.`;
export const NOT_SAVED = () => `The third party client VOD storages could not be added.`;
